package org.example.project

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import org.example.project.ui.EditorApp

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val apiConfig = WebApiConfigProvider.resolveApiConfig()
    val sessionRepository = WebPlatformClient.createSessionRepository(apiConfig)
    val activityApiClient = WebPlatformClient.createActivityApiClient(apiConfig)

    ComposeViewport {
        EditorApp(
            apiConfig = apiConfig,
            sessionRepository = sessionRepository,
            activityApiClient = activityApiClient
        )
    }
}